import * as React from "react";
const SvgFiRrClouds = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-clouds_svg__a)">
      <path
        fill="#062147"
        d="M3 21.123a1 1 0 0 1-.567-.177 5.37 5.37 0 0 1 .51-9.3 7.65 7.65 0 0 1-.8-5.179 8 8 0 0 1 15.49-.84 1.08 1.08 0 0 0 .723.732 7.98 7.98 0 0 1 5.311 5.354 1 1 0 0 1-1.916.572 5.99 5.99 0 0 0-3.983-4.014 3.1 3.1 0 0 1-2.043-2.05 6 6 0 1 0-11.06 4.511 1.994 1.994 0 0 1-.793 2.687 3.37 3.37 0 0 0-.3 5.881A1 1 0 0 1 3 21.123M19.1 24q.54-.026 1.063-.158a4.95 4.95 0 0 0 3.7-3.7 5.01 5.01 0 0 0-3.558-6s-.628-.145-.765-.47a6 6 0 0 0-11.368.855 6.4 6.4 0 0 0-.057 2.732 3.5 3.5 0 0 0 .451 6.59A3.8 3.8 0 0 0 9.4 24zm-1.4-9.556a2.65 2.65 0 0 0 2.089 1.633 3.02 3.02 0 0 1 2.131 3.62 2.98 2.98 0 0 1-2.855 2.276c-1.665.033-8.27.038-9.6 0a1.7 1.7 0 0 1-.379-.055A1.47 1.47 0 0 1 8.057 20.9a1.493 1.493 0 0 1 .85-1.795 2.02 2.02 0 0 0 1.18-2.305 3.99 3.99 0 0 1 1.335-3.883 4 4 0 0 1 6.273 1.53z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-clouds_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrClouds;
